import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { REGISTER_VIEW_ROLES } from '@/features/medication-register/access'
import { RegisterListPage } from '@/features/medication-register/register-list-page'

/**
 * The drugs register list (phase 1b Task 10). Route roles mirror the API's
 * `requireRegisterView` (X2): a clinical approver reads the register but the
 * write pages below admit managers only.
 */
export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/drugs-register/'
)({
  beforeLoad: async () => {
    await requireRoles([...REGISTER_VIEW_ROLES])
    await requireActiveSubscription()
  },
  component: RegisterListPage,
})
